module.exports = "/assets/227bcb28986c4630b648c0f6e0fba40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/A5.png
// module id = 2312
// module chunks = 0